<template>
  <div class="location">
    <label>Location: </label>
    <select v-model="location">
      <option value="all">All Locations</option>
      <option
        v-for="location of availableLocations"
        :key="location.locationId"
        :value="location.locationId"
      >
        {{ location.locationName }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'EventLocation',
  computed: {
    location: {
      get () {
        return this.$store.state.location
      },
      set (location) {
        this.$store.commit('SET_LOCATION', location)
      }
    },
    availableLocations () {
      return this.$store.getters['availableLocations']
    }
  },
  watch: {
    availableLocations (locations) {
      if (!locations.find(it => it.locationId === this.location)) {
        this.location = 'all'
      }
    }
  }
}
</script>
